import React from 'react';
import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme/theme';
import useStore from '../../store/useStore';



import BannerComponent from '../banner';


import CardViewEvents from './CardViewEvents';
import CalendarViewEvents from './CalendarViewEvents';

import ListViewEvents from './ListViewEvents';
import SearchBarEvents from '../filters/SearchBarEvents';
import FilterBarEvents from '../filters/FilterBarEvents';

const HomeEvents = () => {

  const {

    filters,
    GetCurrentEvents,
    view,
    //view /*filters, view, settings*/
  } = useStore((state: any) => ({
    filters: state.filters,
    GetCurrentEvents: state.GetCurrentEvents,
    //gridData: state.MUIdata,
    view: state.settings.params.view,
    //filters: state.filters,
  }));

  //console.log(view)

  useEffect(() => {

    const getData = async () => {
      //await updateData();
      //  await GetCurrentEvents();
      await GetCurrentEvents();
    };


    getData();
  }, [GetCurrentEvents]);


  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BannerComponent title="Events" />

        { /* display Search bar component */}
        <SearchBarEvents />


        {/* display Filters component */}
        <FilterBarEvents />

        {/* display sessions Data grid component */}
        {view === 'card' ? <CardViewEvents /> : view === 'calendar' ? <CalendarViewEvents /> : <ListViewEvents />}


      </div >
    </ThemeProvider >




  );

};

export default HomeEvents;
